import { getObjectKeys } from "../validators/validators";

const useFileSelected = (fileInput, setInput, error, setError) => {
  const fileChangeHandler = (e) => {
    let name = e.target.name;
    let value = e.target.files[0];

    let url = URL.createObjectURL(value);
    let { size } = value;

    // remove item from state object using key
    if (getObjectKeys(error).length !== 0) {
      setError((current) => {
        const copy = { ...current };
        delete copy[name];
        return copy;
      });
    }

    setInput((state) => ({ ...state, [name]: value, temp_url: url }));
  };

  return [fileInput, fileChangeHandler];
};

export default useFileSelected;
